export const SUBMIT_MARKET = (state, market) => { state.market = market };
